import 'pinia-plugin-persistedstate'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { checkAdminSession } from '../composables/auth'

export const useAuthStore = defineStore('auth', () => {
  const authorized = ref<boolean>(false)
  const token = ref<string | null>(null)

  function setAuthStatus(
    newAuthorized: boolean
  ) {
    authorized.value = newAuthorized
  }

  function setToken(
    newToken: string | null
  ) {
    token.value = newToken
  }

  async function refreshSession() {
    await checkAdminSession()
  }

  return { authorized, token, setAuthStatus, setToken, refreshSession }
}, { persist: true })
